/* globals navigator */
import nativeRenderer from './native';
import { getAdUserId } from './helpers';
import { extraSizes } from './config';

const getDevice = () => {
    if (window && window.vgDevice) {
        return window.vgDevice;
    }

    return 'desktop';
};

const getDeviceInvCode = () => {
    const device = getDevice();
    let supplyType = '';

    switch (device) {
        case 'desktop':
            supplyType = 'wde';
            break;

        case 'tablet-app':
            supplyType = 'atb';
            break;

        case 'tablet':
            supplyType = 'wtb';
            break;

        case 'mobile-app':
            supplyType = 'aph';
            break;

        case 'mobile':
            supplyType = 'wph';
            break;

        default:
            supplyType = 'wde';
    }

    return supplyType;
};

const addExtraSizes = ({ invCode, sizes }) => {
    const tagsMap = extraSizes[getDevice()];

    if (tagsMap === undefined || tagsMap[invCode] === undefined) {
        return sizes;
    }

    return [...tagsMap[invCode], ...sizes];
};

const prepareTag = (tag) => {
    const device = getDeviceInvCode();
    const invCode = tag.invCode.replace(/{deviceType}/g, device);
    const sizes = addExtraSizes(tag, device);

    return {
        ...tag,
        invCode,
        sizes,
    };
};

const getFormat = (tagOptions) => {
    const { invCode } = tagOptions;
    return invCode.split(/_(.+)/)[1];
};

const addFormat = (tagOptions) => ({
    'no-sno-adformat': getFormat(tagOptions),
});

const doNotTrack = () =>
    (navigator && navigator.doNotTrack === '1') || getAdUserId() === 'DO_NOT_TRACK';

const preparePageOptions = (pageOpts) => ({
    ...pageOpts,
    user: {
        externalUid: getAdUserId(),
        dnt: doNotTrack(),
    },
});

export const addKeywordsToTag = [addFormat];

export { nativeRenderer, preparePageOptions, prepareTag };



/** WEBPACK FOOTER **
 ** ./src/ads/plugin.js
 **/